import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
// import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ApiV2Service {
  constructor(
    private http: HttpClient,
    private router: Router,
    // private translate: TranslateService
  ) {}

  getService(url: string, paramsInfo?: any) {
    const params: HttpParams = paramsInfo ? paramsInfo : null;
    const options = params ? { params: params } : {};
    return this.http.get(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`,
      options
    );
  }
  getService2(url: string, paramsInfo?: any) {
    const params: HttpParams = paramsInfo ? paramsInfo : null;
    const options = params ? { params: params } : {};
    return this.http.get(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`,
      options
    );
  }

  postService(url: string, body: any) {
    return this.http.post(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`,
      body
    );
  }

  patchService(url: string, body: any) {
    return this.http.patch(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`,
      body
    );
  }

  deleteService(url: string) {
    return this.http.delete(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`
    );
  }
  deleteServiceBody(url: string, body) {
    return this.http.delete(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`,
      body
    );
  }

  getAlternativeService(url: string, path: string | number, paramsInfo?: any) {
    url = environment.endpoints.v2[url].replace(/\{(.*?)\}/, path);
    const params: HttpParams = paramsInfo ? paramsInfo : null;
    const options = params ? { params: params } : {};
    return this.http.get(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`,
      options
    );
  }

  postAlternativeService(url: string, body: any, path: string | number) {
    url = environment.endpoints.v2[url].replace(/\{(.*?)\}/, path);
    return this.http.post(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`,
      body
    );
  }

  patchAlternativeService(url: string, body: any, path: string | number) {
    url = environment.endpoints.v2[url].replace(/\{(.*?)\}/, path);
    return this.http.patch(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`,
      body
    );
  }

  deleteAlternativeService(url: string, path: string | number) {
    url = environment.endpoints.v2[url].replace(/\{(.*?)\}/, path);
    return this.http.delete(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`
    );
  }

  deleteAlternativeServiceBody(url: string, body: any, path: string | number) {
    url = environment.endpoints.v2[url].replace(/\{(.*?)\}/, path);
    return this.http.delete(
      `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${url}`,
      body
    );
  }

  getFile(url: string) {
    return `${environment.apiUrlBase}${environment.endpoints.v1.PREFIX}${url}`;
  }

  postFile(url: string, fileToUpload: File, type?: string): Observable<any> {
    return Observable.create((observer: any) => {
      let fileData: FormData = new FormData();
      fileData.append('file_type', type);
      fileData.append('uploaded_file', fileToUpload, fileToUpload.name);

      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 201) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
          }
        }
      };
      //console.log(localStorage.getItem('token'));
      xhr.open(
        'POST',
        `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`
      );
      xhr.setRequestHeader(
        'Authorization',
        localStorage.getItem('token')
          ? `Token ${JSON.parse(localStorage.getItem('token'))['key']}`
          : ''
      );
      xhr.send(fileData);
    });
  }

  postFile2(url: string, fileToUpload: File, type?: string): Observable<any> {
    return Observable.create((observer: any) => {
      let fileData: FormData = new FormData();
      fileData.append('profile_group_id', type);
      fileData.append('users_file', fileToUpload, fileToUpload.name);

      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
          }
        }
      };
      //console.log(localStorage.getItem('token'));
      xhr.open(
        'POST',
        `${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2[url]}`
      );
      xhr.setRequestHeader(
        'Authorization',
        localStorage.getItem('token')
          ? `Token ${JSON.parse(localStorage.getItem('token'))['key']}`
          : ''
      );
      xhr.send(fileData);
    });
  }

  getExpression(id: number) {
    return `../../assets/img/expressions/expression${id}.svg`;
  }

  // postPrompt(prompt: string): Observable<any> {
  //   const prePrompt = `Eres un asistente virtual que ayuda a profesores a generar actividades cortas que se dividen en escenas.\n`+
  //     `Cada escena es una frase corta.\n`+
  //     `Debes usar un lenguaje simple, claro, sencillo con palabras que puedan ser entendidas por niños pequeños.\n`+
  //     `La respuesta debes dividirla en párrafos indicando que son escenas diferentes.\n`+
  //     `Incluye una escena de saludo y una escena de despedida.\n`+
  //     `El tema de la actividad va a variar dependiendo de lo que el profesor te indique.\n`+
  //     `Debes crear la cantidad de escenas que te indique el profesor.\n`+
  //     `Debes incluir la cantidad de preguntas que te indique el profesor.\n`+
  //     `ejemplo de una actividad cuyo tema es conocer al artista Miró:\n`+
  //     `Escena 1: ¡Hola, qué gusto encontrarme contigo para compartir lindas experiencias!\n`+
  //     `Escena 2: Hoy vamos a aprender nuevas cosas, así que prepárate para disfrutar jugando con líneas, colores, puntos, figuras y mucho más.\n`+
  //     `Escena 3: Antes de comenzar, te recuerdo que siempre estaré atenta a lo que realices, y te esperaré el tiempo que sea necesario.\n`+
  //     `Escena 4: Para iniciar las actividades, te propongo estirarte muchísimo para llenar de energía tu cuerpo, ánimo, yo te esperaré 6 segundos.\n`+
  //     `Escena 5: Hoy vamos a jugar y aprender, siendo artistas, por lo que necesito que tengas cerca una hoja blanca, lápices de colores, algunos plumones, y si tienes cerca, algunas témperas de colores.\n`+
  //     `Escena 6: Tampoco olvides buscar un delantal, así evitaremos ensuciar nuestra ropa, ánimo, busca los materiales con calma, te esperaré un minuto.\n`+
  //     `Escena 7: Maravilloso, observa esta obra de arte y dime, ¿Qué figuras hay?\n`+
  //     `Escena 8: ¿Qué tipo de figuras observaste, en la imagen anterior?\n`+
  //     `Escena 9: ¡Fabuloso, en la obra de arte habían círculos, triángulos y líneas!\n`+
  //     `Escena 10: Ahora, te invito a buscar un espacio cómodo para descubrir, a través de un entretenido video, quién fué Yoán Miró.\n`+
  //     `Escena 11: Recuerdas ¿En qué país nació Miró? Selecciona la respuesta correcta: España, Venezuela, Chile.\n`
  //   const body = {
  //     model: 'text-davinci-003',
  //     prompt: prePrompt + prompt,
  //     max_tokens: 1000,
  //     temperature: 0.9,
  //     top_p: 1,
  //     frequency_penalty: 0,
  //     presence_penalty: 0.6,
  //     stop: '',
  //   };
  //   const url = environment.aiURL;
  //   console.log(url)
  //   return this.http.post(url, body);
  // }

  postPrompt(prompt: string,systemPrompt:string): Observable<any> {
    // var systemPrompt = '';
    // // if (this.translate.currentLang == 'es') {
    //   systemPrompt =
    //     `Eres un asistente virtual que ayuda a profesores a generar actividades cortas que se dividen en escenas.\n` +
    //     `Cada escena es una frase corta.\n` +
    //     `Debes usar un lenguaje simple, claro, sencillo con palabras que puedan ser entendidas por niños pequeños.\n` +
    //     `La respuesta debes dividirla en párrafos indicando que son escenas diferentes.\n` +
    //     `Incluye una escena de saludo y una escena de despedida.\n` +
    //     `El tema de la actividad va a variar dependiendo de lo que el profesor te indique.\n` +
    //     `Debes crear la cantidad de escenas que te indique el profesor.\n` +
    //     `Debes incluir la cantidad de preguntas que te indique el profesor.\n` +
    //     `ejemplo de una actividad cuyo tema es conocer al artista Miró:\n` +
    //     `Escena 1: ¡Hola, qué gusto encontrarme contigo para compartir lindas experiencias!\n` +
    //     `Escena 2: Hoy vamos a aprender nuevas cosas, así que prepárate para disfrutar jugando con líneas, colores, puntos, figuras y mucho más.\n` +
    //     `Escena 3: Antes de comenzar, te recuerdo que siempre estaré atenta a lo que realices, y te esperaré el tiempo que sea necesario.\n` +
    //     `Escena 4: Para iniciar las actividades, te propongo estirarte muchísimo para llenar de energía tu cuerpo, ánimo, yo te esperaré 6 segundos.\n` +
    //     `Escena 5: Hoy vamos a jugar y aprender, siendo artistas, por lo que necesito que tengas cerca una hoja blanca, lápices de colores, algunos plumones, y si tienes cerca, algunas témperas de colores.\n` +
    //     `Escena 6: Tampoco olvides buscar un delantal, así evitaremos ensuciar nuestra ropa, ánimo, busca los materiales con calma, te esperaré un minuto.\n` +
    //     `Escena 7: Maravilloso, observa esta obra de arte y dime, ¿Qué figuras hay?\n` +
    //     `Escena 8: ¿Qué tipo de figuras observaste, en la imagen anterior?\n` +
    //     `Escena 9: ¡Fabuloso, en la obra de arte habían círculos, triángulos y líneas!\n` +
    //     `Escena 10: Ahora, te invito a buscar un espacio cómodo para descubrir, a través de un entretenido video, quién fué Yoán Miró.\n` +
    //     `Escena 11: Recuerdas ¿En qué país nació Miró? Selecciona la respuesta correcta: España, Venezuela, Chile.\n`;
    // } else {
    //   systemPrompt =
    //     `You are a virtual assistant that helps teachers generate short activities that are divided into scenes.\n` +
    //     `Each scene is a short sentence.\n` +
    //     `You must use simple, clear, simple language with words that can be understood by small children.\n` +
    //     `The answer must be divided into paragraphs indicating that they are different scenes.\n` +
    //     `Includes a greeting scene and a farewell scene.\n` +
    //     `The theme of the activity will vary depending on what the teacher tells you.\n` +
    //     `You must create the number of scenes that the teacher tells you.\n` +
    //     `You must include the number of questions indicated by the teacher.\n` +
    //     `example of an activity whose theme is to meet the artist Miró:\n` +
    //     `Scene 1: Hello, how nice to meet you to share nice experiences!\n` +
    //     `Scene 2: Today we are going to learn new things, so get ready to enjoy playing with lines, colors, dots, shapes and much more.\n` +
    //     `Scene 3: Before beginning, I remind you that I will always be attentive to what you do, and I will wait for you as long as necessary.\n` +
    //     `Scene 4: To start the activities, I suggest you stretch a lot to fill your body with energy, cheer up, I'll wait for you 6 seconds.\n` +
    //     `Scene 5: Today we are going to play and learn, being artists, so I need you to have a white sheet nearby, colored pencils, some markers, and if you have them nearby, some colored temperas.\n` +
    //     `Scene 6: Do not forget to look for an apron, so we will avoid dirtying our clothes, cheer up, look for the materials calmly, I will wait for you a minute.\n` +
    //     `Scene 7: Wonderful, look at this work of art and tell me, what figures are there?\n` +
    //     `Scene 8: What kind of figures did you observe, in the previous image?\n` +
    //     `Scene 9: Fabulous, in the artwork there were circles, triangles and lines!\n` +
    //     `Scene 10: Now, I invite you to find a comfortable space to discover, through an entertaining video, who Yoán Miró was.\n` +
    //     `Scene 11: Do you remember in which country was Miró born? Select the correct answer: Spain, Venezuela, Chile.\n`;
    // }
    const body = {
      model: 'gpt-3.5-turbo',
      messages: [
        {
          role: 'system',
          content: systemPrompt,
        },
        {
          role: 'user',
          content: prompt,
        },
      ],
    };
    const url = environment.aiURL;
    console.log(body);
    return this.http.post(url, body);
  }
}

// Eres un asistente virtual que ayuda a profesores a generar actividades cortas que se dividen en escenas. Cada escena es una frase corta. Debes usar un lenguaje simple, claro, sencillo con palabras que puedan ser entendidas por niños pequeños. La respuesta debes dividirla en párrafos indicando que son escenas diferentes. Incluye una escena de saludo y una escena de despedida.  El tema de la actividad va a variar dependiendo de lo que el profesor te indique. Debes crear la cantidad de escenas que te indique el profesor. Debes incluir la cantidad de preguntas que te indique el profesor. ejemplo de una actividad cuyo tema es conocer al artista Miró Escena 1: ¡Hola, qué gusto encontrarme contigo para compartir lindas experiencias! Escena 2: Hoy vamos a aprender nuevas cosas, así que prepárate para disfrutar jugando con líneas, colores, puntos, figuras y mucho más. Escena 3: Antes de comenzar, te recuerdo que siempre estaré atenta a lo que realices, y te esperaré el tiempo que sea necesario. Escena 4: Para iniciar las actividades, te propongo estirarte muchísimo para llenar de energía tu cuerpo, ánimo, yo te esperaré 6 segundos. Escena 5: Hoy vamos a jugar y aprender, siendo artistas, por lo que necesito que tengas cerca una hoja blanca, lápices de colores, algunos plumones, y si tienes cerca, algunas témperas de colores Escena 6: Tampoco olvides buscar un delantal, así evitaremos ensuciar nuestra ropa, ánimo, busca los materiales con calma, te esperaré un minuto Escena 7: Maravilloso, observa esta obra de arte y dime, ¿Qué figuras hay? Escena 8: ¿Qué tipo de figuras observaste, en la imagen anterior? Escena 9: ¡Fabuloso, en la obra de arte habían círculos, triángulos y líneas! Escena 10: Ahora, te invito a buscar un espacio cómodo para descubrir, a través de un entretenido video, quién fué Yoán Miró. Escena 11: Recuerdas ¿En qué país nació Miró? Selecciona la respuesta correcta: España, Venezuela, Chile. Crea una actividad de 5 escenas con 2 preguntas con el tema aprendiendo a sumar. La actividad debe estar adaptada para niños de 4 años.
